(function (root, factory) {
    const pluginName = 'PearsonDropdown';

    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) {
        // eslint-disable-next-line no-undef
        define([], factory(pluginName));
    } else if (typeof exports === 'object') {
        module.exports = factory(pluginName);
    } else {
        root[pluginName] = factory(pluginName);
    }
// eslint-disable-next-line no-unused-vars
}(this, (pluginName) => {
    const defaults = {
        SPACEBAR_KEY_CODE: [0, 32],
        ENTER_KEY_CODE: 13,
        TAB_KEY_CODE: 9,
        DOWN_ARROW_KEY_CODE: 40,
        UP_ARROW_KEY_CODE: 38,
        ESCAPE_KEY_CODE: 27,
        activeClass: 'isActive',
        selectContainer: '.c-select',
        dropdownSelectedNode: '.c-select__button',
        listContainer: '.c-select__dropdown',
        listItems: '.c-select__dropdown-item',
        listItemActive: 'c-select__dropdown-item__active',
        listItemIds: [],
    };

    /**
     * Sets chosen/active item to dropdown button
     * @param {HTMLElement} currentItem
     * @function
     */
    const setSelectedListItem = function (currentItem) {
        const wrapperNode = currentItem.closest(defaults.selectContainer);
        const wrapperItems = wrapperNode.querySelectorAll(defaults.listContainer);
        const dropdownButton = wrapperNode.querySelectorAll(defaults.dropdownSelectedNode);
        const selectedTextToAppend = document.createTextNode(currentItem.firstElementChild.innerText);

        dropdownButton[0].innerHTML = '';
        wrapperItems[0].setAttribute('aria-activedescendant', currentItem.id);
        dropdownButton[0].appendChild(selectedTextToAppend);

        [].forEach.call(document.querySelectorAll(defaults.listItems), (item) => {
            item.removeAttribute('aria-selected');
            item.classList.remove(defaults.listItemActive);
        });

        currentItem.setAttribute('aria-selected', true);
        currentItem.classList.add(defaults.listItemActive);
    };

    /**
     * Sets value of dropdown button and closes the dropdown
     * @function
     */
    const closeList = function () {
        const wrapperNode = document.querySelectorAll(defaults.selectContainer);

        wrapperNode.forEach((elem) => {
            const wrapperItems = elem.querySelectorAll(defaults.listContainer)[0];
            const dropdownButton = elem.querySelectorAll(defaults.dropdownSelectedNode)[0];

            elem.classList.remove(defaults.activeClass);
            wrapperItems.classList.remove(defaults.activeClass);
            dropdownButton.setAttribute('aria-expanded', false);

            if (elem.contains(document.activeElement)) {
                dropdownButton.focus();
            }
        });
    };

    /**
     * Set focus to list elements
     * @function
     */
    const focusNextListItem = function (direction) {
        const { activeElement } = document;

        const currentActiveElementIndex = defaults.listItemIds.indexOf(activeElement.id);

        if (direction === (defaults.DOWN_ARROW_KEY_CODE || defaults.TAB_KEY_CODE)) {
            const currentActiveElementIsNotLastItem = currentActiveElementIndex < defaults.listItemIds.length - 1;

            if (currentActiveElementIsNotLastItem) {
                const nextListItemId = defaults.listItemIds[currentActiveElementIndex + 1];
                document.querySelector('#'.concat(nextListItemId)).focus();
            }
        } else if (direction === defaults.UP_ARROW_KEY_CODE) {
            const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;

            if (currentActiveElementIsNotFirstItem) {
                // eslint-disable-next-line no-underscore-dangle
                const _nextListItemId = defaults.listItemIds[currentActiveElementIndex - 1];
                document.querySelector('#'.concat(_nextListItemId)).focus();
            }
        }
    };

    /**
     * Toggle element visibility
     * @param {DOMNode} elem list of accordion buttons or pricing items
     * @function
     */
    const toggleListVisibility = function (e) {
        const wrapperNode = e.currentTarget.closest(defaults.selectContainer);
        const wrapperItems = wrapperNode.querySelectorAll(defaults.listContainer);
        // eslint-disable-next-line max-len
        const openDropDown = (defaults.SPACEBAR_KEY_CODE.indexOf(e.keyCode) !== -1) || e.keyCode === defaults.ENTER_KEY_CODE;
        const items = wrapperNode.querySelectorAll(defaults.listItems);

        defaults.listItemIds = [];
        if (e.type !== 'click') {
            // Add each list item's id to the listItems array
            items.forEach((elem) => {
                defaults.listItemIds.push(elem.id);
            });
        }

        if (e.type === 'click' || openDropDown) {
            e.preventDefault();
            wrapperNode.classList.toggle(defaults.activeClass);
            wrapperItems[0].classList.toggle(defaults.activeClass);
            wrapperNode.querySelectorAll(defaults.dropdownSelectedNode)[0]
                .setAttribute('aria-expanded', wrapperItems[0].classList.contains(defaults.activeClass));
        }

        if (e.keyCode === defaults.TAB_KEY_CODE) {
            focusNextListItem(defaults.TAB_KEY_CODE);
        }

        if (e.keyCode === defaults.DOWN_ARROW_KEY_CODE) {
            focusNextListItem(defaults.DOWN_ARROW_KEY_CODE);
        }

        if (e.keyCode === defaults.UP_ARROW_KEY_CODE) {
            focusNextListItem(defaults.UP_ARROW_KEY_CODE);
        }
    };

    /**
     * DOM Elements validation
     @private
     @returns {Boolean} true if all required DOM elements are present
     */
    const checkForRequiredDOMElements = function () {
        // Check if dropdown component DOM element is present
        if (!defaults.selectContainer) { return false; }
        // Check if dropdown button is present
        if (defaults.dropdownSelectedNode.length === 0) {
            throw Error('Please provide: dropdownSelectedNode param - dropdown button is missing');
        }
        // Check if dropdown list container is missing its label
        if (defaults.listContainer.length === 0) {
            throw Error('Please provide: listContainer param - dropdown list container is missing');
        }
        // Check if dropdown list items are present
        if (defaults.listItems.length === 0) {
            throw Error('Please provide: listItems param - dropdown component is missing its items');
        }

        return true;
    };

    /**
     * Set click/keydown/keyup events to dropdown button
     * @function
     */
    const dropdownButtonEvent = function () {
        [].forEach.call(document.querySelectorAll(defaults.dropdownSelectedNode), (element) => {
            element.addEventListener('click', (e) => {
                toggleListVisibility(e);
            });

            element.addEventListener('keydown', (e) => {
                // e.preventDefault();
                toggleListVisibility(e);
            });

            element.addEventListener('keyup', (e) => {
                e.preventDefault();
            });
        });
    };

    /**
     * Set click/keydown events to item elements
     * @function
     */
    const listItemsEvent = function () {
        // Create a new event for listening from outside
        const selectDropdownEvent = new CustomEvent('select-dropdown', {
            bubbles: true,
        });
        // Collect all dropdown items
        [].forEach.call(document.querySelectorAll(defaults.listItems), (element) => {
            element.addEventListener('click', (e) => {
                setSelectedListItem(e.currentTarget);
                closeList();
                e.currentTarget.dispatchEvent(selectDropdownEvent);
            });

            element.addEventListener('keydown', (e) => {
                switch (e.keyCode) {
                case defaults.ENTER_KEY_CODE:
                    setSelectedListItem(e.currentTarget);
                    closeList();
                    e.currentTarget.dispatchEvent(selectDropdownEvent);
                    e.preventDefault();
                    break;

                case defaults.DOWN_ARROW_KEY_CODE:
                    focusNextListItem(defaults.DOWN_ARROW_KEY_CODE);
                    e.preventDefault();
                    break;

                case defaults.UP_ARROW_KEY_CODE:
                    focusNextListItem(defaults.UP_ARROW_KEY_CODE);
                    e.preventDefault();
                    break;

                case defaults.ESCAPE_KEY_CODE:
                    closeList();
                    break;

                default:
                    break;
                }
            });
        });
    };

    const focusOutEvent = function () {
        const dropdown = document.querySelectorAll(defaults.selectContainer);

        dropdown.forEach((elem) => {
            elem.addEventListener('focusout', (event) => {
                const target = event.relatedTarget;
                if (!target) { return; }

                if (!elem.contains(target) && elem.classList.contains(defaults.activeClass)) {
                    closeList();
                }
            });
        });
        document.body.addEventListener('click', (event) => {
            if (!event.target.closest(defaults.selectContainer)) {
                closeList();
            }
        });
    };

    /**
     * Plugin Object
     * @constructor
     */
    function Plugin() { this.init(); }

    /**
     * Plugin prototype
     * @public
     * @constructor
     */
    Plugin.prototype = {
        init() {
            // Check for component exists in the DOM
            checkForRequiredDOMElements();
            dropdownButtonEvent();
            listItemsEvent();
            focusOutEvent();
        },

        setActiveItem(element) {
            setSelectedListItem(element);
        },
    };
    return Plugin;
}));
